'use strict';

import modulePaths from 'constants/modulePath';
import moduleCodes from 'constants/moduleCodes';
import routePath from 'constants/routePath';
import queryString from 'query-string';
import {filterToBase64} from './utils/filterUtilities';
const modulePath = modulePaths[moduleCodes.MODULE_INSPECTION_CENTRE];

const getters = {
  getModuleUrl: () => `/${modulePath}`,
  getHomeUrl: () => `/${modulePath}/${routePath.ROUTE_INSPECTION_CENTRE_HOME}`,
  getProfileUrl: () => `/${modulePath}/${routePath.ROUTE_MY_PROFILE}`,
  getConfigurePlanUrl: () => `/${modulePath}/${routePath.ROUTE_INSPECTION_CENTRE_CONFIGURE_PLAN}`,
  getFiltersAndNotificationsUrl: () => `/${modulePath}/${routePath.ROUTE_INSPECTION_CENTRE_FILTERS_AND_NOTIFICATIONS}`,
  getBaseTasksFilterUrl() { return `/${modulePath}/${routePath.ROUTE_INSPECTION_TASKS}`; },
  getTasksFilterUrl: (filterId) => {
    const base = getters.getBaseTasksFilterUrl();
    if (filterId) {
      return `${base}/filter/${filterId}`;
    }
    return `${base}/filter/${routePath.ROUTE_INSPECTION_TASKS_QUERY_ALL}`;
  },

  getTasksQueryFilterUrl: (base, adHocFilter) => {
    const filter = filterToBase64(adHocFilter);
    return `${base}?${queryString.stringify({ [routePath.ROUTE_INSPECTION_TASKS_QUERY_AD_HOC_FILTER]: filter })}`;
  },

  getTaskUrl: (taskId) => {
    const base = `/${modulePath}/${routePath.ROUTE_INSPECTION_TASKS}`;
    if (taskId) {
      return `${base}/${taskId}`;
    }
    return base;
  },

	getAllTasksUrl() {
  	return this.getTaskUrl(routePath.ROUTE_INSPECTION_TASKS_QUERY_ALL);
	},

  getReportsUrl(filterId, adHocFilter) {
    const base = this.getTasksFilterUrl(filterId);
    const reportsUrl = `${base}/reports`;
    return adHocFilter
      ? this.getTasksQueryFilterUrl(reportsUrl, adHocFilter)
      : reportsUrl;
  },
};

export default getters;
